const getIVA = state => {
    return state.iva
}

const getNeto = state => {
    return state.neto
}

const activeMobileItem = state =>
    state.items.find(i => i.id === state.activeMobileItemId)

export default {
    getIVA,
    getNeto,
    activeMobileItem,
}
